module.exports = __webpack_public_path__ + "static/media/landscape1.4e50da73.jpg";